import { render } from "./AppSelect.vue?vue&type=template&id=c8217b40"
import script from "./AppSelect.vue?vue&type=script&lang=js"
export * from "./AppSelect.vue?vue&type=script&lang=js"
script.render = render

export default script